import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.fit());
    this.resizeObserver.observe(this.element);
    this.fit();
  }

  disconnect() {
    this.resizeObserver.disconnect();
  }

  fit() {
    const width = this.element.clientWidth;
    if (!width) return;

    const scale = width / this.contentTarget.offsetWidth;
    this.contentTarget.style.transform = `scale(${scale})`;
    this.contentTarget.style.height = `${this.element.clientHeight / scale}px`;
    this.contentTarget.classList.remove("invisible");
  }
}
